import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
};

const exportSlice = createSlice({
  name: "export",
  initialState,
  reducers: {
    startExport: (state) => {
      state.loading = true;
      state.error = null;
    },
    exportSuccess: (state) => {
      state.loading = false;
    },
    exportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { startExport, exportSuccess, exportFailure } = exportSlice.actions;
export default exportSlice.reducer;
